import { render } from "./SizeApprovalOverride.vue?vue&type=template&id=0901955d&scoped=true"
import script from "./SizeApprovalOverride.vue?vue&type=script&lang=js"
export * from "./SizeApprovalOverride.vue?vue&type=script&lang=js"

import "./SizeApprovalOverride.vue?vue&type=style&index=0&id=0901955d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0901955d"]])

export default __exports__